import { Children, cloneElement, Component } from 'react';

export class ConfirmationResponse extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showQuestion: false
        };
    }
    showQuestionHandler = (bool) => {
        this.setState({ showQuestion: bool });
    };

    render() {
        const { className, children, onSubmit, onCancel } = this.props;

        const childrenWithProps = Children.map(children, (child) =>
            cloneElement(child, {
                onSubmit: onSubmit,
                onCancel: onCancel,
                showQuestionHandler: this.showQuestionHandler,
                showQuestion: this.state.showQuestion
            })
        );

        return <div className={className}>{childrenWithProps}</div>;
    }
}
